import Icon from 'components/atoms/Icon';
import { Tooltip } from '@spotted-zebra-uk/ui-components';
import styles from './InfoIconWithTooltip.module.scss';

const InfoIconWIthTooltip = ({ content }: { content: string }) => {
  return (
    <div className={styles.container}>
      <Tooltip content={content} className={styles.tooltip}>
        <Icon icon="info" />
      </Tooltip>
    </div>
  );
};

export default InfoIconWIthTooltip;
